import { render, staticRenderFns } from "./GfPagescreate.vue?vue&type=template&id=27c19ca3&lang=html&"
import script from "./GfPagescreate.vue?vue&type=script&lang=js&"
export * from "./GfPagescreate.vue?vue&type=script&lang=js&"
import style0 from "./GfPagescreate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports